export type FeaturedImageQualityDemand = {
    renderedWidth: number;
    renderedHeight: number;
    scale: number;
    devicePixelRatio: number;
    availableWidth: number;
    availableHeight: number;
};

export type FeaturedImageUpgradeRequest = {
    demand: FeaturedImageQualityDemand;
    isActive: boolean;
    isClosing: boolean;
    isOriginal: boolean;
    originalRequested: boolean;
};

const resolutionHeadroom = 1.1;

export function shouldUpgradeFeaturedImage(demand: FeaturedImageQualityDemand): boolean {
    const values = Object.values(demand);
    if (values.some(value => !Number.isFinite(value) || value <= 0)) return false;

    const requiredWidth = demand.renderedWidth * demand.scale * demand.devicePixelRatio;
    const requiredHeight = demand.renderedHeight * demand.scale * demand.devicePixelRatio;
    return requiredWidth > demand.availableWidth * resolutionHeadroom
        || requiredHeight > demand.availableHeight * resolutionHeadroom;
}

export function shouldRequestFeaturedImageOriginal(request: FeaturedImageUpgradeRequest): boolean {
    return request.isActive
        && !request.isClosing
        && !request.isOriginal
        && !request.originalRequested
        && shouldUpgradeFeaturedImage(request.demand);
}
